export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
  DOCUMENT = 'document'
}

export interface MediaFile {
  file: File;
  preview: string;
  type: MediaType;
  progress: number;
  uploadedUrl?: string;
  error?: string;
}

export interface MediaUploadProgress {
  id: string;
  progress: number;
  status: 'uploading' | 'completed' | 'error';
  error?: string;
}

export interface MediaUploadOptions {
  maxSize?: number;
  acceptedTypes?: string[];
  folder?: string;
}
